import {Pipe, PipeTransform} from '@angular/core'

/**
 * Chunk Pipe chunks an array into equal length rows,
 * e.g. 10 entries, size 4 -> array of [4,4,2] elements
 *
 * size: size of the rows
 * fill: optionally fill out the last row with null values
 */
@Pipe({
  name: 'chunk',
  standalone: false,
})
export class ChunkPipe implements PipeTransform {
  transform(value: any[], size: number, fill: boolean = false): any[][] {
    let chunks: any[][] = []
    let index = 0
    while (index * size < value.length) {
      const start = index * size
      chunks[index] = value.slice(start, start + size)
      if (fill && chunks[index].length < size) {
        chunks[index] = chunks[index].concat(
          Array(size - chunks[index].length).fill(null),
        )
      }
      index++
    }
    return chunks
  }
}
